import PropTypes from 'prop-types';
import React from 'react';
import {load} from '../state/user/userActions';
import {getUserById} from '../state/user/userSelectors';
import {connect} from 'react-redux';
import AvatarImage from 'components/AvatarImage';
import Icon from 'components/Icon';
import * as Colors from 'constants/Colors';

const sizes = {
  MICRO: 0,
  MEDIUM: 1,
  THUMB: 2,
  LARGE: 3,
};

const sizesToPixels = {
  [sizes.MICRO]: 24,
  [sizes.MEDIUM]: 32,
  [sizes.THUMB]: 40,
  [sizes.LARGE]: 64,
};

class Avatar extends React.Component {
  constructor() {
    super(...arguments);
    this.handleAvatarClick = this.handleAvatarClick.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.load();
  }

  UNSAFE_componentWillReceiveProps() {
    this.props.load();
  }

  handleAvatarClick(e) {
    e.persist();
    e.data = {
      userId: this.props.userId,
    };
    this.props.onAvatarClick && this.props.onAvatarClick(e);
  }

  render() {
    const pixelSize = sizesToPixels[this.props.size];

    if (!this.props.user) {
      return (
        <span
          style={{
            width: pixelSize,
            height: pixelSize,
            border: '1px solid transparent',
            display: 'inline-block',
          }}
        />
      );
    }

    const stylesheet = {
      avatar: {
        borderRadius: '50%',
        width: pixelSize,
        height: pixelSize,
        fontSize: pixelSize,
        boxShadow: `inset 0 0 1px ${Colors.COLOR__BLACK_10}`,
      },
    };

    const styles = {...stylesheet.avatar, ...this.props.style};

    return (
      <AvatarImage
        style={styles}
        className={this.props.className}
        avatarKey={this.props.user.avatarKey}
        onClick={this.handleAvatarClick}
        shade={this.props.shade}
        size={Icon.SIZES[this.props.size]}
        aria-label={`${this.props.user.displayName} Avatar`}
      />
    );
  }
}

Avatar.defaultProps = {
  size: sizes.MICRO,
  style: {},
  shade: Icon.SHADES.LIGHT,
};

Avatar.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  size: PropTypes.number.isRequired,
  onAvatarClick: PropTypes.func,
  style: PropTypes.object,
};

Avatar.sizes = sizes;

export default connect(
  (state, props) => ({
    user: getUserById(state, props.userId),
  }),
  (dispatch, props) => ({
    load: () => dispatch(load(props.userId)),
  })
)(Avatar);
